angular.module('dnecom')
    .controller('SizeProfileModalController', ["$scope", "$uibModalInstance", "sizeProfile", "SizeProfileUtils", "Upload", "$http", "notifications", "ErrorBag", function($scope, $uibModalInstance, sizeProfile, SizeProfileUtils, Upload, $http, notifications, ErrorBag) {
        $scope.loading = false;
        $scope.urlUploading = false;
        $scope.urlUploadBtnText = 'Upload from url';
        $scope.serverErrors = {};

        $scope.sizeProfile = angular.copy(sizeProfile.sizeProfile || sizeProfile);

        $scope.countries = TemplateData.value('countries');

        $scope.init = function () {
            $scope.columns = $scope.getProfileColumns();
            $scope.columnsCount = $scope.columns.length.toString();
        };

        $scope.save = function() {
            $scope.serverErrors = {};
            $scope.loading = true;
            var sizeProfile = $scope.sizeProfile;
            var id = 0;
            if (sizeProfile.hasOwnProperty('id')) {
                id = sizeProfile.id;
            }

            var url = null;

            if (id) {
                url = Routing.generate('size_profile_update', {
                    id: id
                });
            } else {
                url = Routing.generate('size_profile_add', {});
            }

            $http.put(url, sizeProfile)
                .then(function(response) {
                    $scope.loading = false;
                    if (response.data.success) {
                        notifications.success('Size profile saved.');
                        $scope.sizeProfile = response.data.sizeProfile;

                        $uibModalInstance.close({
                            sizeProfile: $scope.sizeProfile
                        });
                    } else {
                        notifications.danger(response.data.message);
                    }
                }, function(response) {
                    $scope.loading = false;
                    if (response.status == 422) {
                        notifications.danger('Form contains invalid data.');

                        $scope.serverErrors = ErrorBag.from(response.data.errors);
                    } else {
                        notifications.danger('Request error.');
                    }
                });
        };

        $scope.cancel = function() {
            $uibModalInstance.dismiss('cancel');
        };

        $scope.onColumnCountChange = function() {
            SizeProfileUtils.adjustColumns($scope.sizeProfile, parseInt($scope.columnsCount));
            $scope.columns = $scope.getProfileColumns();
            $scope.columnsCount = $scope.columns.length.toString();
        };

        $scope.getProfileSizes = function () {
            return SizeProfileUtils.getProfileSizes($scope.sizeProfile);
        };

        $scope.getProfileColumns = function () {
            return SizeProfileUtils.getProfileColumns($scope.sizeProfile);
        };

        $scope.updateColumnName = function (newValue, index) {
            SizeProfileUtils.updateColumnName($scope.sizeProfile, newValue, index);
        };

        var beforeImageUpload = function() {
            $scope.urlUploadBtnText = 'Uploading...';
            $scope.urlUploading = true;
        };

        var afterImageUpload = function() {
            $scope.urlUploadBtnText = 'Upload from url';
            $scope.urlUploading = false;
        };

        $scope.upload = function (file) {
            beforeImageUpload();

            Upload.upload({
                    url: Routing.generate('upload_file', {store: 0}),
                    data: {
                        file: file
                    }
                })
                .then(function (response) {
                    if (response.data.success) {
                        $scope.sizeProfile.sizeGraphic = response.data.media;
                    } else {
                        notifications.danger(response.data.message);
                    }

                    afterImageUpload();
                }, function () {
                    notifications.danger('There was a problem with image uploading.');
                    afterImageUpload();
                });
        };

        $scope.uploadFromUrl = function (url) {
            if (!url || !url.length) {
                return;
            }

            beforeImageUpload();

            $http.post(Routing.generate('upload_file', {store: 0}), {
                    image: url
                })
                .then(function (response) {
                    if (response.data.success) {
                        $scope.sizeProfile.sizeGraphic = response.data.media;
                    } else {
                        notifications.danger(response.data.message);
                    }

                    afterImageUpload();
                }, function () {
                    notifications.danger('There was a problem with image uploading.');
                    afterImageUpload();
                });
        };

        $scope.removeSize = function (size, index) {
            if (size.hasOwnProperty('id')) {
                $http.delete(Routing.generate('size_profile_size_delete', {profileId: $scope.sizeProfile.id, id: size.id}))
                    .then(function (response) {
                        if (response.data.success) {
                            notifications.success('Size has been deleted successfully.');
                        } else {
                            notifications.danger(response.data.message);
                        }
                    }, function () {
                        notifications.danger('There was a problem with deleting size.');
                    });
            }
            $scope.sizeProfile.sizes.splice(index, 1);
        };

        $scope.addSize = function () {
            var values = [];
            for (var i = 0; i < $scope.columnsCount; i++) {
                values.push({column: $scope.columns[i], value: {cm: '', inch: ''}});
            }
            $scope.sizeProfile.sizes.push({
                name: '',
                values: values
            });
        };

        $scope.fromCm = function (value) {
            value.inch = SizeProfileUtils.fromCmToInch(value.cm);
        };

        $scope.fromInch = function (value) {
            value.cm = SizeProfileUtils.fromInchToCm(value.inch);
        };
    }]);
